import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { Icon } from '../Icon';
import styles from './HeaderV5.css';

const cx = classnames.bind(styles);

function HeaderV5({ className, renderLeftNavigation, url, isFinished, hasBackButton, onBack }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    const wrapperClasses = cx({ wrapper: true, finished: isFinished });

    const renderBackButton = () => (
        <button
            type='button'
            className={styles.backButton}
            onClick={() => onBack()}
            aria-label='Go back'
        >
            <Icon name='arrowLeft' />
        </button>
    );

    return (
        <header className={classes}>
            <div className={wrapperClasses}>
                {hasBackButton && renderBackButton()}
                <CustomLink to={url} className={cx({ logoText: true, finished: isFinished })}>
                    Boundly
                </CustomLink>
                {Boolean(renderLeftNavigation) && renderLeftNavigation()}
            </div>
        </header>
    );
}

HeaderV5.propTypes = {
    className: PropTypes.string,
    renderLeftNavigation: PropTypes.func,
    url: PropTypes.string.isRequired,
    isFinished: PropTypes.bool.isRequired,
    hasBackButton: PropTypes.bool,
    onBack: PropTypes.func
};

HeaderV5.defaultProps = {
    className: '',
    renderLeftNavigation: null,
    hasBackButton: false,
    onBack: null
};

export {
    HeaderV5
};
